import BanksList from "../components/Banks/BanksList";

export default function BanksPage(){

    return (
      <BanksList/>
    );
}